export const CONFIG = JSON.parse(process.env.CONFIG || '{}');
export const REDUX_STORAGE_KEY = '__REDUX_STORAGE__';
export const CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export const MANDATE_RAISED_FIELD_OPTIONS = [
  { value: 'raised', label: 'Raised' },
  { value: 'committed', label: 'Committed' },
];

export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es', 'it'];

export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
}

export const ENTITY_TYPES = [
  {
    value: 1,
    label: 'Angel Investor',
  },
  {
    value: 2,
    label: 'Family Office',
  },
  {
    value: 3,
    label: 'VC & PE',
  },
  {
    value: 4,
    label: 'Venture/ hedge fund',
  },
  {
    value: 5,
    label: 'Investments/private Bank',
  },
  {
    value: 6,
    label: 'Financial Institution',
  },
  {
    value: 7,
    label: 'Corporate / Strategic Investor',
  },
  {
    value: 8,
    label: 'Investment Advisor / Asset Manager',
  },
  {
    value: 9,
    label: 'Other',
  },
];

export const TIME_SPOTS = [
  {
    value: '10:00-11:30',
    label: '10:00-11:30',
  },
  {
    value: '11:30-13:00',
    label: '11:30-13:00',
  },
  {
    value: '13:00-14:30',
    label: '13:00-14:30',
  },
  {
    value: '14:30-16:00',
    label: '14:30-16:00',
  },
  {
    value: '16:00-17:30',
    label: '16:00-17:30',
  },
  {
    value: '17:30-19:00',
    label: '17:30-19:00',
  },
];
